<template>
  <div class="mt-48 to2-exercise">
    <div class="relative flex flex-col h-auto flex-1 w-full pt-4 pb-20">
      <div class="w-full max-w-[1200px] mx-auto px-4">
        <h1 class="text-4xl font-bold mb-8">Teckningsoptioner av serie TO 2</h1>

        <div class="bg-blue-50 border-l-4 border-custom-blue-500 p-6 mb-8">
          <h2 class="text-2xl font-bold mb-4">Första teckningsperioden: 1 – 15 september 2026</h2>
          <div class="space-y-2">
            <p class="text-gray-600">
              Två (2) teckningsoptioner av serie TO 2 berättigar till teckning av en (1) ny aktie till en teckningskurs om 1,00 SEK per aktie.
            </p>
            <p class="text-gray-600">
              Innehavare vars teckningsoptioner är <strong>förvaltarregistrerade</strong> (depå hos bank eller nätmäklare) anmäler teckning till och enligt instruktion från sin förvaltare.
            </p>
            <p class="text-gray-600">
              Innehavare vars teckningsoptioner är <strong>direktregistrerade</strong> på VP-konto anmäler teckning på särskild anmälningssedel som tillhandahålls av Aqurat Fondkommission AB.
            </p>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Utnyttjandet i sammandrag</h2>
          <div class="space-y-4">
            <p>
              Teckningsoptionerna av serie TO 2 emitterades inom ramen för den kompensationsemission som beslutades av årsstämman den 30 juni 2026 i Windon Energy Group AB (publ) ("Windon" eller "Bolaget"). Optionerna delades ut vederlagsfritt genom sakutdelning till Bolagets befintliga aktieägare, i syfte att ge dessa möjlighet att delvis motverka den ägarutspädning som följde av apportemissionen och kvittningsemissionen i samband med förvärvet av solparksportföljen om 22,19 MW.
            </p>
            <p>
              Vid fullt utnyttjande av samtliga 18 240 000 teckningsoptioner under den första teckningsperioden emitteras 9 120 000 nya aktier och Bolaget tillförs cirka 9,1 MSEK före emissionskostnader, vilka beräknas uppgå till cirka 0,1 MSEK. Utspädningen uppgår därvid till cirka 5,0 procent av kapitalet och rösterna i Bolaget.
            </p>
            <p>
              Likviden avses användas till rörelsekapital i den löpande verksamheten, fortsatta investeringar i Bolagets befintliga solparksanläggningar – däribland installation av batterilager (BESS) vid anläggningar med befintlig nätanslutning – samt investeringar i nya anläggningar.
            </p>
            <p>
              Teckningsoptioner som inte utnyttjas under den första teckningsperioden kvarstår och kan utnyttjas under den andra teckningsperioden, från och med den 1 juni 2027 till och med den 15 juni 2027, till en teckningskurs om 1,50 SEK per aktie. Teckningsoptioner som inte utnyttjas inom angivna teckningsperioder upphör att gälla och förfaller utan värde.
            </p>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Villkor för teckning</h2>
          <div class="bg-white shadow rounded-lg overflow-hidden">
            <table class="w-full">
              <tbody class="divide-y divide-gray-200">
                <tr>
                  <td class="px-6 py-4 font-medium">Teckningsperiod:</td>
                  <td class="px-6 py-4">1 september 2026 – 15 september 2026</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Teckningskurs:</td>
                  <td class="px-6 py-4">1,00 SEK per aktie</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Teckningsrelation:</td>
                  <td class="px-6 py-4">Två (2) teckningsoptioner av serie TO 2 berättigar till teckning av en (1) ny aktie</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Emissionsvolym:</td>
                  <td class="px-6 py-4">Högst 9 120 000 nya aktier</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Emissionslikvid:</td>
                  <td class="px-6 py-4">Högst 9 120 000 SEK före emissionskostnader</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Andra teckningsperioden:</td>
                  <td class="px-6 py-4">1 juni 2027 – 15 juni 2027, till en teckningskurs om 1,50 SEK per aktie</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Sista handelsdag i TO 2:</td>
                  <td class="px-6 py-4">11 juni 2027</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Emissionsinstitut:</td>
                  <td class="px-6 py-4">Aqurat Fondkommission AB</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">Handel i nya aktier:</td>
                  <td class="px-6 py-4">Omkring september/oktober 2026 på Spotlight Stock Market</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="text-sm text-gray-600 mt-3">
            Betalning för tecknade aktier ska erläggas kontant samtidigt med anmälan om teckning. Teckning kan endast ske av det hela antal aktier som det sammanlagda antalet teckningsoptioner berättigar till; eventuell överskjutande del av en teckningsoption som inte kan utnyttjas lämnas utan avseende. Anmälan om teckning är bindande och kan inte återkallas eller ändras.
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Dokument / bilagor</h2>
          <div class="space-y-3">
            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/documents/WEG_forenklat_Informationsdokument.docx"
              target="_blank"
              title="Förenklat informationsdokument"
            >
              <i class="bx bxs-file-doc text-custom-blue-500 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Förenklat informationsdokument</span>
            </a>

            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/documents/Styrelsens_redogoorelse_14kap32_signerad.pdf"
              target="_blank"
              title="Styrelsens redogörelse för händelser av väsentlig betydelse enligt 14 kap. 32 § första stycket 4 aktiebolagslagen"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Styrelsens redogörelse enligt 14 kap. 32 § första stycket 4 aktiebolagslagen</span>
            </a>

            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/documents/Revisorsyttrande_14kap32_signerad.pdf"
              target="_blank"
              title="Revisorns yttrande över styrelsens redogörelse enligt 14 kap. 32 § första stycket 4 aktiebolagslagen"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Revisorns yttrande över styrelsens redogörelse enligt 14 kap. 32 § aktiebolagslagen</span>
            </a>

            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/documents/Villkor-for-teckningsoptioner-TO-2.pdf"
              target="_blank"
              title="Fullständiga villkor för teckningsoptioner av serie TO 2"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Fullständiga villkor för teckningsoptioner av serie TO 2</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <Footer
      class="w-full"
      @go-to-index="$emit('go-to-index', $event)"
    />
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'TO2Exercise',
  components: {
    Footer
  }
}
</script>

<style lang="scss" scoped>
.to2-exercise {
  p {
    @apply my-2;
  }

  h1, h2, h3, h4 {
    @apply font-bold;
  }

  h1 {
    @apply text-4xl pb-2 mb-4;
  }

  h2 {
    @apply text-2xl;
  }

  h3 {
    @apply text-xl;
  }

  h4 {
    @apply text-lg;
  }

  a {
    @apply text-custom-blue-500;
  }
}
</style>
